// extracted by mini-css-extract-plugin
var _1 = "FilterModal-modulebutton__TI307";
var _2 = "FilterModal-modulefilter__iY9o4";
var _3 = "FilterModal-modulenotification__riir4";
var _4 = "FilterModal-moduleselect___xXZc";
var _5 = "FilterModal-moduleswitch__X60N2";
export { _1 as "button", _2 as "filter", _3 as "notification", _4 as "select", _5 as "switch" }
